<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3 0H9.7C1.9 0 0 1.9 0 9.7v8.6C0 26.1 1.9 28 9.7 28h8.6c7.8 0 9.7-1.9 9.7-9.7V9.7C28 1.9 26.1 0 18.3 0zm4 8.9c.6 0 .8.3.6.7a23 23 0 0 1-2.7 4.7c-.2.4-.3.6 0 1l.6.6.8.8c.9 1 1.5 1.8 1.7 2.4.2.6-.1.9-.7.9h-2c-.6 0-.8-.3-1.4-1l-1-1c-1.2-1.2-1.8-1.4-2-1.4-.5 0-.6.1-.6.7v1.9c0 .5-.1.8-1.5.8-2.1 0-4.5-1.3-6.2-3.8a16.5 16.5 0 0 1-3.2-6.8c0-.3.1-.5.7-.5h2c.6 0 .8.2 1 .8 1 2.9 2.6 5.4 3.3 5.4.3 0 .4-.1.4-.8v-3c0-.8-.3-1.2-.6-1.5l-.2-.5c0-.2.2-.4.5-.4H15c.5 0 .6.2.6.7v4c0 .5.2.7.3.7.3 0 .5-.2 1-.7 1.4-1.6 2.5-4.1 2.5-4.1.1-.3.4-.6.9-.6h2z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconVK',
};
</script>
